export const initialViewState: ViewState = {
  isLoading: false,
  slideMenuVisibility: false,
}

export interface ViewState {
  isLoading: boolean,
  slideMenuVisibility: boolean,
}
